import { Controller } from "@hotwired/stimulus";

// Expands/collapses per-facility year subrows on the producer gap calculations table.
export default class extends Controller {
  static targets = ["subrow", "chevron"];

  connect() {
    this._syncChevron();
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.subrowTargets.length === 0) return;

    const show = this.subrowTargets.some((el) => el.classList.contains("hidden"));
    this.subrowTargets.forEach((el) => el.classList.toggle("hidden", !show));
    const expanded = this.subrowTargets.some((el) => !el.classList.contains("hidden"));
    const btn = this.element.querySelector("button[aria-expanded]");
    if (btn) btn.setAttribute("aria-expanded", String(expanded));
    this._syncChevron();
  }

  _syncChevron() {
    if (!this.hasChevronTarget) return;
    const expanded =
      this.subrowTargets.length > 0 && !this.subrowTargets[0].classList.contains("hidden");
    this.chevronTarget.classList.toggle("-rotate-90", !expanded);
    this.chevronTarget.classList.toggle("rotate-0", expanded);
  }
}
